<template lang="pug">
div.popupNps
  v-dialog(v-model="popupNps" scrollable persistent width="370")
    v-card.popup-nps
      v-card-text
        .close
          img(:src="iconClose" alt="Cerrar pop-up NPS" style="float:right" width="12px" @click="closePopup")
        p.omnesRegular.text-primary(style="text-align: center;")
          | Del&nbsp;
          span.omnesSemibold 0 al 10, ¿qué tan probable&nbsp;
          | es que nos recomiendes a familiares o amigos?
        .score-avatar
          img(
            :src="flagSelectedScore ? selectedScoreInfo.img : imgStart"
            alt="Personaje animado"
            )
        ul.score-list
          PopupNpsList(
            v-for="scoreItem in scoreData"
            :key="scoreItem.id"
            :scoreItem="scoreItem"
            :scoreVal="score"
            @select="selectScoreNps"
            :class="{'high-score': scoreItem.id > 8, 'low-score': scoreItem.id < 7}"
            )
        p.omnesRegular.text-secondary.g-text-center(v-show="!flagSelectedScore")
          | *Donde&nbsp;
          span.omnesSemibold 0&nbsp;
          | es&nbsp;
          span.omnesSemibold “Nada probable”&nbsp;
          br
          | y el&nbsp;
          span.omnesSemibold 10&nbsp;
          | es&nbsp;
          span.omnesSemibold “Muy probable”
          | .
        div(v-show="flagSelectedScore")
          .score-container
            p
              span.omnesSemibold.score {{ selectedScoreInfo.id }}
              span.omnesSemibold /10
            p.omnesSemibold {{ selectedScoreInfo.meaning }}
          .score-instruction
            p.omnesRegular
              span(v-for="(item, index) in selectedScoreInfo.instruction" :key="index" :class="{'omnesSemibold': item.bold}")
                | {{ item.text }}
              span(:class="{'omnesSemibold': selectedScoreInfo.id > 8}")
                | Por favor, indica la razón de tu calificación.
          v-layout(row wrap v-if="flagSelectedScore" style="justify-content: center;")
            .btn-category(
              v-for="(category, index) in getCategoriesNPS(selectedScoreInfo.nps)" :key="index"
              :class="{'btn-category-selected' : npsCategorySelected === category}"
              @click="selectCategoryNps(category)"
            )
              span {{ category }}
          .score-comment(v-if="flagSelectedScore && npsCategorySelected.toLowerCase().includes('otros')")
            textarea(placeholder="Escribe aquí" :maxlength="commentLength" v-model="comment")
            span.omnesRegular Máximo 250 caracteres.
        .button-container
          v-btn.omnesSemibold(:class="{'disabled': !npsCategorySelected || (npsCategorySelected.toLowerCase().includes('otros') && !validateComment(comment))}" @click.prevent="sendScoreNps") Enviar
  PopupNpsFinal(
    :showPopup="$store.state.nps.popupNpsFinal"
    :imgClose="iconClose"
    :imgAvatar="imgEnd"
    )
</template>

<script>
import PopupNpsList from '@/components/modals/nps/PopupNpsList'
import PopupNpsFinal from '@/components/modals/nps/PopupNpsFinal'
import { mapActions } from 'vuex'
import moment from 'moment'

// Tiempo de inactividad
const downtime = 1000 * 60 * 5

export default {
  data () {
    return {
      popupNps: false,
      lastActivity: null,
      taggeo: {},
      iconClose: require('@/assets/nps/icon-close-nps-modal.svg'),
      imgStart: require('@/assets/nps/person-start.svg'),
      imgEnd: require('@/assets/nps/person-end.gif'),
      flagSelectedScore: false,
      score: null,
      scoreData: [
        {
          id: 0,
          img: require('@/assets/nps/person-0-1-2.svg'),
          meaning: 'Nada probable',
          instruction: [
            { bold: false, text: 'Lamentamos lo sucedido, ' },
            { bold: true, text: '¿qué salió mal? ' }
          ],
          nps: 'detractor'
        },
        {
          id: 1,
          img: require('@/assets/nps/person-0-1-2.svg'),
          meaning: 'Nada probable',
          instruction: [
            { bold: false, text: 'Lamentamos lo sucedido, ' },
            { bold: true, text: '¿qué salió mal? ' }
          ],
          nps: 'detractor'
        },
        {
          id: 2,
          img: require('@/assets/nps/person-0-1-2.svg'),
          meaning: 'Nada probable',
          instruction: [
            { bold: false, text: 'Lamentamos lo sucedido, ' },
            { bold: true, text: '¿qué salió mal? ' }
          ],
          nps: 'detractor'
        },
        {
          id: 3,
          img: require('@/assets/nps/person-3-4.svg'),
          meaning: 'Poco probable',
          instruction: [
            { bold: false, text: '¡Oh no!, ' },
            { bold: true, text: '¿en qué podemos mejorar? ' }
          ],
          nps: 'detractor'
        },
        {
          id: 4,
          img: require('@/assets/nps/person-3-4.svg'),
          meaning: 'Poco probable',
          instruction: [
            { bold: false, text: '¡Oh no!, ' },
            { bold: true, text: '¿en qué podemos mejorar? ' }
          ],
          nps: 'detractor'
        },
        {
          id: 5,
          img: require('@/assets/nps/person-5-6.svg'),
          meaning: 'Algo probable',
          instruction: [
            { bold: false, text: 'Entiendo, ' },
            { bold: true, text: '¿en qué podemos mejorar? ' }
          ],
          nps: 'detractor'
        },
        {
          id: 6,
          img: require('@/assets/nps/person-5-6.svg'),
          meaning: 'Algo probable',
          instruction: [
            { bold: true, text: '¿Qué debemos mejorar para ser muy recomendados? ' }
          ],
          nps: 'detractor'
        },
        {
          id: 7,
          img: require('@/assets/nps/person-7-8.svg'),
          meaning: 'Probable',
          instruction: [
            { bold: true, text: '¿Qué debemos mejorar para ser muy recomendados? ' }
          ],
          nps: 'pasivo'
        },
        {
          id: 8,
          img: require('@/assets/nps/person-7-8.svg'),
          meaning: 'Probable',
          instruction: [
            { bold: true, text: '¿Qué debemos mejorar para ser muy recomendados? ' }
          ],
          nps: 'pasivo'
        },
        {
          id: 9,
          img: require('@/assets/nps/person-9.svg'),
          meaning: 'Muy probable',
          instruction: [],
          nps: 'promotor'
        },
        {
          id: 10,
          img: require('@/assets/nps/person-10.svg'),
          meaning: 'Extremadamente probable',
          instruction: [],
          nps: 'promotor'
        }
      ],
      npsCategorySelected: '',
      npsCategories: {
        promotor: ['Información del producto', 'Diseño y navegación', 'Programa de Beneficios', 'Práctico y fácil', 'Experiencia de pago', 'Facilidad de realizar cambios y modificaciones', 'Servicio post venta', 'Buena experiencia con Interseguro', 'No tengo problemas', 'Otros'],
        pasivo: ['Mejora en información', 'Mejora en diseño y navegación', 'Mejorar el programa de beneficios', 'Mejorar la rentabilidad del producto', 'Solución a mis tramites/solicitudes', 'Mejorar en la experiencia de pago', 'Agregar nuevas funciones', 'Otros'],
        detractor: ['Información errada y/o incompleta', 'Diseño y navegación', 'Problemas con los beneficios', 'Problemas con el producto', 'No tengo solución a mis trámites/solicitudes', 'Problemas de descarga', 'Problemas de pago', 'Servicio post venta', 'Otros']
      },
      selectedScoreInfo: [],
      comment: '',
      commentLength: 250
    }
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    ...mapActions('nps', ['updateEventLogNps', 'getNps', 'sendNps', 'setPopupNpsFinal']),
    getDate () {
      return moment().format('YYYY-MM-DD')
    },
    selectScoreNps (id) {
      this.score = id
      this.flagSelectedScore = true
      this.npsCategorySelected = ''
      this.scoreData.forEach(objScore => {
        if (this.score === objScore.id) {
          this.selectedScoreInfo = objScore
        }
      })
    },
    getCategoriesNPS (id) {
      return this.npsCategories[id]
    },
    selectCategoryNps (category) {
      this.npsCategorySelected = category
    },
    reset () {
      this.flagSelectedScore = false
      this.score = ''
      this.comment = ''
      this.selectedScoreInfo = []
      this.updateEventLogNps({
        nombre: 'NPS Zona Segura',
        fecha: null,
        datos: {
          numeroPoliza: null,
          productoConsultado: null,
          subproductoConsultado: null,
          seccion: null,
          funcionalidad: null,
          calificacion: null,
          razonCalificacion: null,
          inactividad: null,
          showNps: null,
          _response: null
        }
      })
    },
    formatDataNps (obj) {
      return {
        'tipoDocumento': obj.tipoDocumento,
        'numeroDocumento': obj.numeroDocumento,
        'categoria': obj.categoria,
        'nombre': obj.nombre,
        'datos': {
          'numeroPoliza': obj.datos.numeroPoliza,
          'productoConsultado': obj.datos.productoConsultado,
          'subproductoConsultado': obj.datos.subproductoConsultado,
          'seccion': obj.datos.seccion,
          'funcionalidad': obj.datos.funcionalidad,
          'calificacion': this.score,
          'razonCalificacion': this.npsCategorySelected,
          'otros': this.comment
        },
        'fecha': obj.fecha
      }
    },
    sendScoreNps () {
      const self = this

      self.showNps = false
      self.popupNps = false
      self.taggeo.datos.boton = 'Enviar'

      this.updateEventLogNps({
        nombre: 'NPS - Encuesta Finalizada',
        fecha: this.getDate(),
        datos: Object.assign(this.$store.state.nps.taggeoNps.datos, {
          ...self.taggeo.datos,
          calificacion: this.score,
          razonCalificacion: this.npsCategorySelected,
          otros: this.comment
        })
      })
      self.taggeo = { ...this.$store.state.nps.taggeoNps }

      const dataNps = this.formatDataNps(self.taggeo)

      self.sendNps(dataNps)
        .then((res) => {
          if (res.data.codigoRespuesta === '01') {
            this.$store.commit('nps/setPopupNpsFinal', true)
          }
          self.eventLog(dataNps)
        })
        .catch((err) => {
          self.taggeo.datos._error = err
          self.eventLog(self.taggeo)
        })
      self.reset()
    },
    closePopup () {
      const self = this
      self.popupNps = false
      self.taggeo = { ...this.$store.state.nps.taggeoNps }
      self.taggeo.datos.showNps = false
      self.taggeo.fecha = self.getDate()
      self.taggeo.nombre = 'NPS - Encuesta Finalizada'
      self.taggeo.datos.boton = 'Cerrar'

      self.eventLog(self.taggeo)
      self.reset()
    },
    isInactive () {
      const time = new Date() - this.lastActivity
      if (time >= downtime) {
        return true
      }
      return false
    },
    validateComment (comment) {
      // Expresión regular para validar si el comentario contiene al menos un carácter que no sea un espacio en blanco, un número o un símbolo
      const regex = /^(?!\s*$|^[0-9]+$).*/
      // Comprueba si el comentario coincide con la expresión regular
      return regex.test(comment)
    }
  },
  mounted () {
    const self = this

    self.$root.$on('showNps', ({nombre, funcionalidad, metadata}) => {
      self.taggeo = { ...this.$store.state.nps.taggeoNps }
      self.taggeo.fecha = self.getDate()
      self.taggeo.datos.funcionalidad = funcionalidad
      self.taggeo.nombre = nombre
      self.taggeo.datos.showNps = false
      self.taggeo.datos.inactividad = false
      if (metadata) {
        self.taggeo.datos = { ...self.taggeo.datos, ...metadata }
      }
      self.getNps()
        .then(res => {
          if (res.data.codigoRespuesta === '01' && res.data.mostrar) {
            self.taggeo.datos.showNps = true
            self.popupNps = true
            self.eventLog(self.taggeo)
          } else {
            self.taggeo.datos._response = res.data
          }
        })
        .catch((err) => {
          self.taggeo.datos._error = err
          self.eventLog(self.taggeo)
        })
    })

    self.$root.$on('npsInactivity', ({seccion, funcionalidad, metadata}) => {
      self.lastActivity = new Date()
      self.taggeo = { ...this.$store.state.nps.taggeoNps }
      self.taggeo.fecha = self.getDate()
      self.taggeo.nombre = 'NPS - Inicio de Encuesta'
      if (metadata) {
        self.taggeo.datos = { ...self.taggeo.datos, ...metadata }
      }
      self.taggeo.datos.seccion = seccion
      setTimeout(() => {
        if (this.lastActivity && this.isInactive()) {
          self.taggeo.datos.inactividad = true
          self.lastActivity = null
          this.updateEventLogNps({
            datos: Object.assign(this.$store.state.nps.taggeoNps.datos, { funcionalidad: funcionalidad || null })
          })
          self.getNps()
            .then(res => {
              if (res.data.codigoRespuesta === '01' && res.data.mostrar) {
                self.taggeo.datos.showNps = true
                self.popupNps = true
              } else {
                self.taggeo.datos.showNps = false
                self.taggeo.datos._response = res.data
              }
              self.eventLog(self.taggeo)
            })
            .catch((err) => {
              self.taggeo.datos._error = err
              self.eventLog(self.taggeo)
            })
        }
      }, downtime)
    })

    self.$root.$on('npsActivity', () => {
      self.lastActivity = null
    })
  },
  components: {
    PopupNpsList,
    PopupNpsFinal
  }
}
</script>

<style>
.popupNps .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 90%;
}
.popup-nps .v-card__text {
  padding: 34px 18px;
}

.popup-nps .close {
  cursor: pointer;
  margin: 5px;
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

.popup-nps p,
.popup-nps span {
  color: #535D66;
  margin: 0;
}

.popup-nps .text-primary,
.popup-nps .text-primary span {
  font-size: 18px;
  line-height: 20px;
}

.popup-nps .text-secondary,
.popup-nps .text-secondary span {
  font-size: 16px;
  line-height: 18px;
}

.popup-nps .text-secondary {
  margin: 0 auto 85px;
}

.popup-nps .score-avatar {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.popup-nps .score-avatar img{
  width: 120px;
}

.popup-nps .score-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 11px;
  row-gap: 21px;
  margin: 0 auto 13px;
  width: 90%;
}

.popup-nps .score-list .item {
  width: 34px;
  height: 34px;
  border: 2px solid #FFD645;
  border-radius: 50%;
  color: #FFD645;
  cursor: pointer;
  font-size: 18px;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: .2s ease-in-out;
  user-select: none;
}

.popup-nps .score-list .item.low-score {
  border-color:var(--fuchsia-color);
  color: var(--fuchsia-color);
}

.popup-nps .score-list .item.high-score {
  border-color:#00B28D;
  color: #00B28D;
}

.popup-nps .score-list .item.selected {
  background: #FFD645;
  color: #fff;
}

.popup-nps .score-list .item.low-score.selected {
  background: var(--fuchsia-color);
}

.popup-nps .score-list .item.high-score.selected {
  background: #00B28D;
}

.popup-nps .score-container {
  margin: 8px 0;
}

.popup-nps .score-container p {
  color: #0855C4;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  margin: 0;
}

.popup-nps .score-container span {
  color: #D4DBEA;
  font-size: 20px;
  line-height: 25px;
}

.popup-nps .score-container .score {
  color: #0855C4;
  font-size: 28px;
  line-height: 35px;
}

.popup-nps .score-instruction p,
.popup-nps .score-instruction span {
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  margin-bottom: 10px;
}

.popup-nps .score-comment {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}

.popup-nps .score-comment textarea {
  border: 1px solid #C4C4C4;
  border-radius: 3px;
  color: #535D66;
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  margin: auto;
  padding: 6px 8px;
  width: 95%;
  min-height: 30px;
  transition: .2s ease-in-out;
}

.popup-nps .score-comment textarea:focus-visible {
  outline: none !important;
  border-color: #0855C4;
}

.popup-nps .score-comment span {
  font-size: 12px;
  padding-left: 12px;
  margin-top: 3px;
}

.popup-nps .button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;
}

.popup-nps .button-container button {
  background: var(--fuchsia-color) !important;
  box-shadow: none !important;
  border-radius: 4px;
  color: white;
  font-size: 18px;
  width: 145px;
  height: 47px;
  margin: 0;
  text-transform: capitalize;
}

.popup-nps .button-container button.disabled {
  background: #EAEAEA !important;
  pointer-events: none;
}

.btn-category {
  display: flex;
  align-items: center;
  border-radius: 15px;
  background: #F0F0F0;
  height: 28px;
  cursor: pointer;
  margin: 5px 5px 0px 3px;
}
.btn-category span {
  color: #454A6C;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.5px;
  cursor: pointer;
  padding: 0px 10px;
}
.btn-category-selected {
  border: 1.034px solid #0855C4;
  background: #DDEBFF;
}

.btn-category-selected span {
  font-family: 'Omnes Semibold';
  color: #0855C4;
}

@media screen and (max-width: 385px) {
  .popup-nps .text-secondary {
    margin-bottom: 45px;
  }

  .popup-nps .score-list {
    width: 100%;
  }

  .popup-nps .score-comment textarea {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .popupNps .v-dialog.v-dialog--active.v-dialog--persistent.v-dialog--scrollable {
    width: 420px !important;
  }
}

@media screen and (min-width: 1024px) {
  .popup-nps .v-card__text {
    padding: 25px;
  }

  .popup-nps .close {
    padding: 6px;
  }

  .popup-nps .text-primary,
  .popup-nps .text-primary span {
    font-size: 16px;
  }

  .popup-nps .text-secondary,
  .popup-nps .text-secondary span {
    font-size: 16px;
    line-height: 19px;
  }

  .popup-nps .text-secondary {
    margin: 0 auto 30px;
  }

  .popup-nps .score-list {
    column-gap: 8px;
    row-gap: 15px;
    width: 70%;
  }

  .popup-nps .score-list .item {
    width: 25px;
    height: 25px;
    font-size: 16px;
    line-height: 20px;
  }

  .popup-nps .score-container span {
    font-size: 16px;
    line-height: 20px;
  }

  .popup-nps .score-container .score {
    font-size: 23px;
    line-height: 28px;
  }

  .popup-nps .score-instruction p,
  .popup-nps .score-instruction span {
    font-size: 16px;
  }

  .popup-nps .score-comment textarea {
    font-size: 14px;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/nps/PopupNps.vue